/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, ReactNode, useState} from 'react'
import classNames from 'classnames'
import {useIntl} from 'react-intl'
import { DropdownMenu, SettingModalOption, SettingOption } from './DropdownMenu'
import { Link } from 'react-router-dom'
import { renderIdentifier } from '../../util/Constants'

interface Props {
  loading: boolean
  title?: string
  subTitle?: string
  pathOnClickHandler: string
  closeOnClickHandler: () => void
  settingOptions?: SettingOption[]
  settingsLoading?: boolean
  shareSettingOption?: SettingModalOption
  removeSettingOption?: SettingModalOption
  content: ReactNode
}

const PreviewCard: FC<Props> = ({
  loading,
  title,
  subTitle,
  closeOnClickHandler,
  pathOnClickHandler,
  settingOptions,
  settingsLoading = false,
  shareSettingOption,
  removeSettingOption,
  content,
}) => {
  const intl = useIntl()
  const [openDropDown, setOpenDropDown] = useState(false)

  return (
    <div
      className={classNames('col-12', 'col-lg-7', {
        'col-12': content,
      })}
    >
      <div className='card card-custom card-flush'>
        <div className='card-body'>
          <div className='d-flex flex-row'>
            <div className='d-flex flex-column flex-row-fluid'>
              <div className='d-flex flex-row flex-column-fluid'>
                <div className='d-flex flex-row-fluid flex-start'>
                  {content && (
                    <div className='d-flex flex-column'>
                      <span className='fs-2 fw-bolder'>
                        <Link className='' to={`${pathOnClickHandler}`}>
                          {title}
                        </Link>
                      </span>
                      <span className='fw-bolder text-gray-800 me-1 fs-5'>
                        {renderIdentifier(subTitle)}
                      </span>
                    </div>
                  )}
                </div>

                <div className='d-flex flex-row-auto flex-start ms-5'>
                  {content && (
                    <>
                      {(settingOptions || removeSettingOption) && (
                        <>
                          <button
                            className='btn btn-sm btn-light-primary me-2'
                            onClick={() => setOpenDropDown((prev) => !prev)}
                            disabled={settingsLoading}
                          >
                            {settingsLoading ? (
                              <span className='indicator-progress' style={{display: 'block'}}>
                                <span className='spinner-border spinner-border-sm align-middle'></span>
                              </span>
                            ) : (
                              <i className='bi bi-three-dots fs-5'></i>
                            )}
                          </button>
                          <DropdownMenu
                            visible={openDropDown}
                            setOpenDropDown={setOpenDropDown}
                            settingOptions={settingOptions}
                            shareOption={shareSettingOption}
                            deleteOption={removeSettingOption}
                          ></DropdownMenu>
                        </>
                      )}
                    </>
                  )}

                  <button className='btn btn-sm btn-light' onClick={closeOnClickHandler}>
                    <i className='bi bi-x-lg'></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {loading ? (
            <div className='row'>
              <div className='d-flex flex-row-fluid flex-center w-350px h-300px'>
                <div className='spinner-border text-primary' role='status'></div>
              </div>
            </div>
          ) : !content ? (
            <div className='row'>
              <div className='d-flex flex-row-fluid flex-start mt-10'>
                <span className='text-danger '>
                  <div className='d-flex flex-row justify-content-start align-items-center'>
                    <span className='fs-6 me-1'>
                      <i className='text-danger me-1 bi bi-exclamation-octagon' />
                      {intl.formatMessage({id: 'ERROR.MESSAGE.SERVICE_UNAVAILABLE'})}
                    </span>
                  </div>
                </span>
              </div>
            </div>
          ) : (
            <>
              <div>
                <div className='separator mt-5'></div>
                {content}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export {PreviewCard}
